(() => {
  'use strict';
  if (window.UnchemedClassicContext) return;
  const node = document.getElementById('unc-classic-catalog');
  if (!node) return;
  let product;
  try { product = JSON.parse(node.textContent); } catch (_) { return; }
  const keys = ['starter', 'annual', 'double'], ids = product.ids;
  if (!product.valid || String(product.id) !== '10117770084599' || !keys.every(k => product.variants.some(v => String(v.id) === ids[k]))) return;
  function resolve(search) {
    const params = new URLSearchParams(search);
    const offer = params.get('classic_offer') || ((product.nativeProductPage || product.productLandingPage) ? params.get('offer') : null);
    return keys.includes(offer) ? offer : keys.find(k => ids[k] === (params.get('classic_variant') || params.get('variant'))) || 'annual';
  }
  let selected = resolve(location.search), original = window._adtrProductDetails || {};
  function nativeProduct() {
    const variant = product.variants.find(v => String(v.id) === ids[selected]);
    return {...original, id:String(product.id), title:product.name, brand:'Unchemed', sku:variant.sku, price:variant.price, product_type:'Showerhead Kit', images:[product.image], variants:[{...variant, id:String(variant.id)}]};
  }
  if (product.nativeProductPage === true) {
    try { Object.defineProperty(window, '_adtrProductDetails', {configurable:true, enumerable:true, get:nativeProduct, set:value => { original = value || {}; }}); }
    catch (_) { window._adtrProductDetails = nativeProduct(); }
  }
  window.UnchemedClassicContext = Object.freeze({product, ids, resolve, getSelected:() => selected, setSelected:key => {if (keys.includes(key)) selected = key;}});
})();

